export default {"src":"/_next/static/media/info-icon.9b20f644.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};